// extracted by mini-css-extract-plugin
export default {"wrapper":"form-error_wrapper__GnGEK"};